import { makeAutoObservable, runInAction } from "mobx";

/**
 * Page-local UI state for add/edit employee. Kept out of the shared EmployeeStore
 * so listing and other screens do not inherit form loading/saving flags.
 */
export class EmployeeFormUiStore {
  isLoading = true;
  permissionsLoading = false;
  loadError: string | null = null;
  isSaving = false;
  saveError: string | null = null;
  saveNotice: string | null = null;
  permissionsError: string | null = null;
  copyResetKey = 0;

  private savingLock = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setLoading(value: boolean) {
    this.isLoading = value;
  }

  setPermissionsLoading(value: boolean) {
    this.permissionsLoading = value;
  }

  setLoadError(message: string | null) {
    this.loadError = message;
  }

  setPermissionsError(message: string | null) {
    this.permissionsError = message;
  }

  setSaveNotice(message: string | null) {
    this.saveNotice = message;
  }

  setSaveError(message: string | null) {
    this.saveError = message;
  }

  beginSave(): boolean {
    if (this.savingLock || this.isSaving) return false;
    this.savingLock = true;
    this.isSaving = true;
    this.saveError = null;
    this.saveNotice = null;
    return true;
  }

  endSave() {
    this.savingLock = false;
    this.isSaving = false;
  }

  bumpCopyResetKey() {
    this.copyResetKey += 1;
  }

  clearSaveNoticeSoon(delayMs = 4000) {
    const notice = this.saveNotice;
    if (!notice) return;
    window.setTimeout(() => {
      runInAction(() => {
        if (this.saveNotice === notice) this.saveNotice = null;
      });
    }, delayMs);
  }
}
